<template>
    <div>
        <div class="top">

        </div>
        <div class="left">
            <div v-for="item in menu" class="menu-main">
                <p class="title main" @click="item.open = !item.open">{{ item.title }}</p>
                <div :class="['menu-sub',{ open: item.open }]">
                    <p class="lt"></p>
                    <div v-for="item in item.sub">
                        <p class="title sub" @click="select(item.fn)">{{ item.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            menu: [
                { title: 'Things 1', open: false, sub: [
                    { title: 'Sub 1', fn: 't1.1' },
                    { title: 'Sub 2', fn: 't1.2' }
                ]},
                { title: 'Thing 2', open: false, sub: [
                    { title: 'Sub 1', fn: 't2.1' },
                    { title: 'Sub 2', fn: 't2.2' }
                ]},
                { title: 'Thing 3', open: false, sub: [
                    { title: 'Sub 1', fn: 't3.1' },
                    { title: 'Sub 2', fn: 't3.2' }
                ]}
            ]
        }
    },
    methods: {
        select ( fn ) {
            console.log(fn);
        }
    }
}

</script>

<style scopped lang="scss">
.top {
    position: fixed;
    top: 0px;
    left: 0px;
    height: 50px;
    width: 100%;
    background-color: rgba(172, 75, 75, 1)
}
.left {
    position: fixed;
    top: 50px;
    left: 0px;
    width: 160px;
    height: calc(100% - 50px);
    background-color: rgba(172, 75, 75, 1);
    > div:nth-child(1) {
        border-top: 1px solid white;
        width: 100%;
    }
    .title {
        color: white;
        text-align: left;
        padding: 10px;
        border-bottom: 1px solid white;
    }
    .menu-sub {
        position: relative;
        .lt {
            position: absolute;
            top: -30px;
            left: calc(100% - 25px);
            transition: transform 0.3s;
        }
        > div {
            display: none;
        }
        .title { text-align: right; }
        &.open {
            .lt {
                transform: rotate(-90deg);
            }
            > div {
                display: inline;
            }
        }
    }
}
.lt {
    width: 20px;
    height: 20px;
    position: relative;
    left: 100px;
    &:before,&:after {
        content: '';
        width: 10px;
        height: 2px;
        background-color: white;
        position: absolute;
        top: 6px;
        left: 3px;
        transform: rotate(-45deg);
    }
    &:after {
        top: 12px;
        transform: rotate(45deg);
    }
}
</style>